import React from "react";
import { AccordionSummary } from "@mui/material";

const DSAccordionSummary = (
  props: React.ComponentProps<typeof AccordionSummary>,
) => {
  return <AccordionSummary {...props} />;
};

export default DSAccordionSummary;
